import { ArrowUpRight } from "lucide-react";

export default function CTABanner() {
    return (
        <section
            data-testid="cta-banner"
            className="relative bg-signal text-white overflow-hidden"
        >
            <div className="absolute inset-0 opacity-30 bg-[linear-gradient(135deg,transparent_46%,rgba(0,0,0,0.15)_50%,transparent_54%)] bg-[length:24px_24px]" />
            <div className="container-x relative py-20 sm:py-28">
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-8">
                        <p className="text-xs uppercase tracking-[0.2em] text-white/80 font-bold mb-4">
                            — Prêt à commencer ?
                        </p>
                        <h2 className="font-display font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.95]">
                            Rejoignez Carvaelis
                            <br />
                            dès aujourd'hui.
                        </h2>
                    </div>
                    <div className="lg:col-span-4 lg:col-start-9 flex lg:justify-end">
                        <a
                            href="https://carvaelis.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="cta-banner-button"
                            className="group inline-flex items-center justify-between gap-3 bg-ink hover:bg-white hover:text-ink text-white px-8 py-6 font-bold uppercase tracking-wider text-sm transition-colors w-full lg:w-auto"
                        >
                            Accéder à la plateforme
                            <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
